module.exports = __webpack_public_path__ + "static/media/hwseta_logo.38474db9.jpg";